import { DateTimeWrapper } from './styled'
import DatePicker from "react-datepicker"
import { useState } from "react"
import "react-datepicker/dist/react-datepicker.css";

const DateTimePicker = ({ dateInit, readOnly = false, onChangeDate }) => {
    const [startDate, setStartDate] = useState(dateInit ?? new Date());
    return (
        <DateTimeWrapper>
            <DatePicker selected={startDate} onChange={(date) => { !readOnly && setStartDate(date); !readOnly && onChangeDate(date) }} />
        </DateTimeWrapper>
    )
}

export default DateTimePicker